import React, { useState, useRef, useEffect } from "react";
import FontAwesome from "react-fontawesome";
import { toast } from "react-toastify";
import { read, utils } from "xlsx";
import Aleart from "../common/popupAlert";
import Select from "../common/selectcustom";
import { make_cols } from "../excel/makecoluns";
import moment from "moment";
import { NavLink, Link } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ArskConfirm from "../common/confirmSubmit";
import { savedeletebyexcel } from "../../services/facescan";
import { SheetJSFT } from "../excel/types";
// import { importProduct, downloadProductMaster } from '../../../services/manage/product/productService';
// import ReactJson from 'react-json-view'
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";

import UserImportlist from "./importuserlist";

const ProductImport = ({ isOpenModal, onClose, id }) => {
  const filePond = useRef();
  const [importFile, setImportFile] = useState(undefined);
  const [formData, setformData] = useState({});
  const [isOpen, setisOpen] = useState(false);
  const [message, setmessage] = useState("");
  const [doInsert, setDoInsert] = useState(true);
  const [doUpdate, setDoUpdate] = useState(true);
  const [filearray, setfilearray] = useState([]);
  const [listmarket, setlistmarket] = useState([]);
  const [isSave, setisSave] = useState(false);
  const [isOpenConfirm, setisOpenConfirm] = useState(false);
  // useEffect(() => {

  //   const loadData = async () => {

  //     try {
  //       const { data: result } = await getmastermarket();
  //       if (result.status === "success") {
  //         setlistmarket(result.data.list);
  //       }
  //     } catch (ex) {
  //       toast.error(ex.message);
  //     }
  //   };
  //   loadData();
  // }, []);

  const handleSelectFile = (err, input) => {
    if (err) return toast.error("File Error ", err.message);
    const { file } = input;

    if (file) {
      setImportFile(file);
    } else {
      toast.info("File is not found");
      return;
    }
    handleFile();
    // const doc = { fileName: importFile.name };

    // ChekDataUpload(doc)
  };

  const handleSelectChange = (inputKey, data) => {
    setformData({
      ...formData,
      [inputKey]: JSON.parse(data),
    });
  };
  const handleUploadButton = () => {
    if (filePond && filePond.current) {
      filePond.current.browse();
    }
  };
  const handleFile = async () => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    let data;
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = read(bstr, { type: rABS ? "binary" : "array", bookVBA: true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      data = utils.sheet_to_json(ws);
      /* Update state */
      //   setstateFile({ data: data, cols: make_cols(ws["!ref"]) }, () => {
      //     console.log(JSON.stringify(stateFile.data, null, 2));
      //   });
    };

    // if (rABS) {
    //   reader.readAsBinaryString(stateFile.file);
    // } else {
    //   reader.readAsArrayBuffer(stateFile.file);
    // }
  };

  const submitUploadCheck = async () => {
    try {
      if (!importFile) return toast.error("File Upload is missing");

      const doc = { fileName: importFile.name };

      //   const {data: result} = await importProduct(doc, importFile);
      //   if (result.status==='success') {
      //       toast.success("OK")

      //       setTest(result.data.size)

      //   } else {
      //       toast.error(result.message)
      //   }
    } catch (err) {}
  };

  const submitUpload = () => {
    setisOpenConfirm(true);
    // const doc = { supplierid: formData.marketid, productlist: file };
    // try {
    //   // const { data: result } = await importproduct(doc)
    //   // if (result.status==='success') {
    //   //     toast.success(result.message)
    //   //     setfilearray([])
    //   // }else {
    //   //     toast.error(result.message)
    //   // }
    // } catch (err) {}
  };

  const doSubmit = async () => {
    const sublist = [...filearray];
    const filelist = sublist.filter((item) => item.employeeid);
    // console.log(sublist,filelist )
    if (filelist.length === 0) {
      setmessage("กรุณา import file ก่อน");
      setisOpen(true);
      return;
    }
    submitUpload(filelist);
  };

  const downloadMasterProduct = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        // const {data: result, headers } = await downloadProductMaster()

        // if( result.status==='error') {
        //     toast.error(result.message)
        // } else {
        //     if ( headers['x-suggested-filename']==='nodata') {
        //         toast.error("No Document")
        //     } else {
        //         jsfiledownload(result, headers['x-suggested-filename'] || `document.xlsx`)
        //     }
        // }

        setTimeout(() => {
          resolve("ok");
        }, 300);
      } catch (err) {
        toast.error("Error : ", err.message);
        resolve("error");
      }
    });
  };
  const handleChange = (e) => {
    const files = e.target.files;
    if (files.length) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = utils.sheet_to_json(worksheet);
        setfilearray(json);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    } else {
      setfilearray([]);
    }
  };
  const savedata = () => {};

  const onClosemodal = () => {
    onClose();
  };

  const onOK = () => {
    setisOpen(false);
    setmessage("");
  };
  const onCancelConfirm = () => {
    setisOpenConfirm(false);
  };

  const doSubmitDelete = async () => {
    const doc = {
      employeelist: filearray,
      faceid: id,
    };
    const { data: result } = await savedeletebyexcel(doc);
    // console.log(result)

    if (result.status === "success") {
      setisSave(false)
      setisOpenConfirm(false)
      onClose()
      setfilearray([])
      toast.success(result.message);
    } else {
      toast.error(result.message);
    }
  };
  const onConfirmDelete = () => {
    doSubmitDelete();
  };
  const header = moment().format("D MMMM YYYY HH:mm");
  return (
    <>
      <ArskConfirm
        size="sm"
        message={"ท่านยืนยันที่บันทึกรายการใช่หรือไม่"}
        isOpen={isOpenConfirm}
        onConfirm={onConfirmDelete}
        onCancel={onCancelConfirm}
        button1={"ยืนยัน"}
      />
      <Aleart isOpen={isOpen} message={message} onOk={onOK} />
      <Modal
        isOpen={isOpenModal}
        toggle={onClosemodal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader></ModalHeader>

        <ModalBody>
          <h4 className="mb-2">Import EmployeeID : {header}</h4>
          <div className="row p-1">
            <div className="col">
              <h5>ขั้นตอนการเตรียมไฟล์</h5>
              <p>1. เอกสาร Excel</p>
              <p>2. ข้อมูลอยู่ใน Work Sheet แรก</p>
              <p>3. Headers อยู่บรรทัดแรก และประกอบด้วย</p>
              <p>
                <b>employeeid</b>
              </p>
              <span className="badge bg-warning text-dark">
                <Link
                  to="/template/employeeimport.xlsx"
                  target="_blank"
                  download
                >
                  {" "}
                  <i className="bi bi-download mx-2"></i> Download here Master
                  Employee Template
                </Link>
              </span>
              <p className="mt-2">Note: Skip first 1 rows</p>
            </div>
          </div>

          <div className="container-fluid">
            <div className="card ">
              <h5 className="d-inline m-2 ms-4">Emplolyee</h5>

              <h6
                className="card-text d-inline me-2"
                style={{ fontSize: "14px" }}
              >
                <span className="text-primary" /> {"ตรวจพบ "} {filearray.length}{" "}
                {" รายการ"}
              </h6>

              <div className="col-auto ml-auto ">
                {importFile && (
                  <span className="mr-3 text-success">
                    <FontAwesome name="check-circle" /> File Ready :{" "}
                    {importFile.name}
                  </span>
                )}
                {/* {!importFile && <FileUploader tag="aa" notifyFileAdd={file => setImportFile(file)}  />} */}
                {importFile && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setImportFile(undefined)}
                  >
                    Remove
                  </button>
                )}

                <div className="row m-2 ">
                  <div className="col-auto col-lg-6 my-1">
                    <input
                      type="file"
                      className="form-control"
                      id="file"
                      accept={SheetJSFT}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-auto my-1">
                    <button
                      type="button"
                      disabled={isSave}
                      className="btn btn-info btn-sm"
                      onClick={() => doSubmit()}
                    >
                      <span className="mx-4 ">Confirm Upload</span>
                    </button>
                  </div>
                </div>

                {/* {!importFile && (
              <React.Fragment>
                <div className="d-none">
                  <FilePond
                    labelIdle="อัพโหลด"
                    ref={filePond}
                    onaddfile={(error, file) => handleSelectFile(error, file)}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={handleUploadButton}
                >
                  Upload
                </button>
              </React.Fragment>
            )} */}
              </div>
            </div>
          </div>
          <UserImportlist list={filearray} />
        </ModalBody>
        <ModalFooter>
          {isSave && (
            <Button color="primary" onClick={savedata}>
              บันทึก
            </Button>
          )}
          <Button color="secondary" onClick={onClosemodal}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
      {/* <div className="card-body py-2 pt-3"> */}
      {/* <div className="row align-items-center"> */}
      {/* <div className="col-auto text-center mb-2">
                <h5 className="d-inline">Product</h5>
              </div> */}
      {/* <div className="col-auto mb-2">
                <input
                  checked={doInsert}
                  type="checkbox"
                  onChange={(e) => setDoInsert(e.target.checked)}
                />
                <h6 className="d-inline ml-2">Insert</h6>
              </div> */}
      {/* <div className="col-auto mb-2">
                <input
                  checked={doUpdate}
                  type="checkbox"
                  onChange={(e) => setDoUpdate(e.target.checked)}
                />
                <h6 className="d-inline ml-2">Update</h6>
              </div> */}

      {/* <div className="col-auto ml-auto mb-2"> */}
      {/* {importFile && (
                  <span className="mr-3 text-success">
                    <FontAwesome name="check-circle" /> File Ready :{" "}
                    {importFile.name}
                  </span>
                )} */}
      {/* {!importFile && <FileUploader tag="aa" notifyFileAdd={file => setImportFile(file)}  />} */}
      {/* {importFile && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setImportFile(undefined)}
                  >
                    Remove
                  </button>
                )} */}
      {/* {!importFile && (
                  <React.Fragment>
                    <div className="d-none">
                      <FilePond
                                  labelIdle="อัพโหลด"
                                  ref={filePond}
                                  onaddfile={(error, file) => handleSelectFile(error, file)}
                                />
                    </div>
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={handleUploadButton}
                    >
                      Upload
                    </button>
                  </React.Fragment>
                )} */}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}

      {/* {!finish && (
        <div className="row justify-content-center mt-4">
          <div className="col-auto text-center">
                <button type="button" className="btn btn-info" disabled={!importFile} onClick={submitUploadCheck} >Submit Test</button>
            </div>
          <div className="col-auto text-center">
            <button
              type="button"
              className="btn btn-primary"
              disabled={!(importFile && (doInsert || doUpdate))}
              onClick={subimport { import } from '../../vendor/highlightjs/highlight.pack.min';
mitUploadBill}
            >
              Confirm Import
            </button>
          </div>
        </div>
      )} */}
      {/* {test && !finish && 
            <div>
                <ReactJson src={test} name={false} theme="summerfruit:inverted" displayDataTypes={false} displayObjectSize={false} />
                <button type="button" className="btn btn-secondary" onClick={()=> setTest(undefined)} >Clear Test</button>
            </div>
        }
        {finish && <div className="row no-gutters">
            <div className="col-12">
                <ReactJson src={finish} name={false} theme="summerfruit:inverted" displayDataTypes={false} displayObjectSize={false} />
            </div>
        
        </div>} */}
      {/* <h4 className="mt-4">Export Product </h4>
        <ButtonDownload className="btn btn-secondary mr-2" label='Download Master Products' onClick={downloadMasterProduct} /> */}
    </>
  );
};

export default ProductImport;
